/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * this enumeration contains all davinci glow defined events
 */
export var Events;
(function (Events) {
    Events["CAMERACHANGED"] = "onCameraChanged";
    Events["VIEWPORTCHANGED"] = "onViewportChanged";
    Events["VIEWPORTUPDATED"] = "onViewportUpdated";
    Events["OBJECTADDED"] = "onObjectAdded";
    Events["OBJECTREPLACED"] = "onObjectReplaced";
    Events["OBJECTREMOVED"] = "onObjectRemoved";
    Events["OBJECTCLICKED"] = "onObjectClicked";
    Events["OBJECTUNCLICKED"] = "onObjectUnclicked";
    Events["OBJECTTOUCHED"] = "onObjectTouched";
    Events["OBJECTDRAGGED"] = "onObjectDragged";
    Events["OBJECTRELEASED"] = "onObjectReleased";
    Events["GIZMOCHANGED"] = "onGizmoChanged";
    Events["GIZMOTRANSFORM"] = "onGizmoTransform";
    Events["ACTORFINISHED"] = "onActorFinished";
})(Events || (Events = {}));
//# sourceMappingURL=Events.js.map